import { useEffect, useState } from "react"
import ProductCard2 from "./ProductCard2"

function MostFilledProductList({ updated }) {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    const controller = new AbortController()

    const loadData = async () => {
      try {
        setLoading(true)
        setError(false)

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/products/filter`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ filters: { mostFilled: true }, limit: 5 }),
            signal: controller.signal,
          },
        )

        if (!res.ok) throw new Error("Failed to fetch products")

        const data = await res.json()

        setProducts(data.products || [])
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("MostFilledProductList error:", err)
          setError(true)
          setProducts([])
        }
      } finally {
        setLoading(false)
      }
    }

    loadData()

    return () => controller.abort()
  }, [updated])

  /* ---------------- UI STATES ---------------- */

  if (loading) {
    return (
      <div className="text-center mb-5">
        <h2 className="lead fs-4 text-dark">Loading...</h2>
        <div className="spinner-border text-primary fs-3 mt-3" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="text-center">
        <h2 className="lead fs-4 text-danger">
          Failed to load most filled products
        </h2>
      </div>
    )
  }

  if (products.length === 0) {
    return (
      <div className="text-center">
        <h2 className="lead fs-4 text-muted">
          No Most Filled products available.
        </h2>
      </div>
    )
  }

  /* ---------------- UI ---------------- */

  return (
    <section className="container-fluid col-11 mt-4">
      <h1 className="home-title text-center mb-3">MOST FILLED ORDERS</h1>
      <div className="ProductList product-row">
        {products.map((p) => (
          <ProductCard2 key={p.product_id} product={p} />
        ))}
      </div>
    </section>
  )
}

export default MostFilledProductList
